export default {
  firebase: {
    tangle: {
      apiKey: 'AIzaSyAXHwpVl43ZmTDY1uRG3S_u_XmQWqmmeyg',
      authDomain: 'tangle-157402.firebaseapp.com',
      databaseURL: 'https://tangle-157402.firebaseio.com',
      projectId: 'tangle-157402',
      storageBucket: 'tangle-157402.appspot.com',
      messagingSenderId: '769582483126',
      appId: '1:769582483126:web:a6dbcac41da1ad9cd10817',
    },
    stage: {
      apiKey: 'AIzaSyAXHwpVl43ZmTDY1uRG3S_u_XmQWqmmeyg',
      authDomain: 'tangle-157402.firebaseapp.com',
      databaseURL: 'https://tangle-157402.firebaseio.com',
      projectId: 'tangle-157402',
      storageBucket: 'tangle-157402.appspot.com',
      messagingSenderId: '769582483126',
      appId: '1:769582483126:web:a6dbcac41da1ad9cd10817',
    },
    tangledev: {
      apiKey: 'AIzaSyAXHwpVl43ZmTDY1uRG3S_u_XmQWqmmeyg',
      authDomain: 'tangle-157402.firebaseapp.com',
      databaseURL: 'https://tangle-157402.firebaseio.com',
      projectId: 'tangle-157402',
      storageBucket: 'tangle-157402.appspot.com',
      messagingSenderId: '769582483126',
      appId: '1:769582483126:web:a6dbcac41da1ad9cd10817',
    },
    hktangle: {
      apiKey: 'AIzaSyCZOtyZgHU4_jEM9jXRjHnxerCYIfdbX-o',
      authDomain: 'ws://hktangle-auth.herokuapp.com',
      // authDomain: 'ws://localhost:3001',
      databaseURL: 'wss://protected-shelf-59777.herokuapp.com', // proxy to => https://hktangle.firebaseio.com
      // databaseURL: 'ws://localhost:3000',
      projectId: 'hktangle',
      storageBucket: 'hktangle.appspot.com',
      messagingSenderId: '866982697074',
      appId: '1:866982697074:web:3055afbac9bb1f5dd64aeb',
    },
  },
  midServer: {
    tangle: 'https://us-central1-tangle-157402.cloudfunctions.net',
    // tangle: 'http://localhost:5000/tangle-157402/us-central1',
    stage: 'https://us-central1-playbookstaging.cloudfunctions.net',
    tangledev: 'https://us-central1-tangledev-test.cloudfunctions.net',
    hktangle: 'https://us-central1-hktangle.cloudfunctions.net',
    // hktangle: 'http://localhost:5000/hktangle/us-central1',
  },
}
